import * as React from 'react';

function useCursor(hovered) {
  let onPointerOver = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'pointer';
  let onPointerOut = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'auto';
  React.useEffect(() => {
    if (hovered) {
      document.body.style.cursor = onPointerOver;
      return () => void (document.body.style.cursor = onPointerOut);
    }
  }, [hovered]);
}

export { useCursor };